export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    confirm: 'Confirm',
    close: 'Close',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    visible: 'Visible',
    sectionTitle: 'Section Title',
    sectionDescription: 'Section Description',
    selectLanguage: 'Select Language',
    saveChanges: 'Save Changes',
    saveSuccess: 'Saved successfully',
    title: 'Title',
    name: 'Name',
    location: 'Location',
    description: 'Description',
    imageUrl: 'Image URL',
    price: 'Price',
    link: 'Link',
    copy: 'Copy',
    paste: 'Paste',
    show: 'Show',
    hide: 'Hide',
    heroSection: 'Hero Section'
  },
  login: {
    title: 'Travelbolt CMS',
    subtitle: 'Sign in to manage your content',
    username: 'Username',
    password: 'Password',
    signIn: 'Sign In',
    incorrect: 'Incorrect username or password',
    failed: 'Login failed, please try again',
    successful: 'Login successful'
  },
  menu: {
    destinations: 'Popular Destinations',
    flightDeals: 'Prime Flight Deals',
    services: 'Our Travel Services',
    hotDeals: 'Hot Deals & Promotions',
    hotDealDetails: 'Hot Deal Details',
    flashSale: 'Flash Sale',
    testimonials: 'What Our Travelers Say',
    exclusiveDeals: 'Get Exclusive Travel Deals',
    exclusiveTravelInsurance: 'Exclusive Travel Insurance',
    heroBackground: 'Hero Background/Logo',
    subscribers: 'Subscribers Management',
    users: 'User Management',
    languages: 'Language Management',
    destinationDetails: 'Destination Details',
    flightDealDetails: 'Flight Deal Details',
    footer: 'Footer Management',
    marketing: 'Marketing Management',
    faqs: 'FAQ Management',
    aboutUs: 'About Us Management',
    contentManagement: 'Content Management',
    systemManagement: 'System Management'
  },
  footer: {
    title: 'Footer Management',
    companyName: 'Company Name',
    companyDescription: 'Company Description',
    socialMedia: 'Social Media',
    icon: 'Icon',
    link: 'Link',
    addSocialMedia: 'Add Social Media',
    quickLinks: 'Quick Links',
    url: 'URL',
    addQuickLink: 'Add Quick Link',
    supportLinks: 'Support Links',
    addSupportLink: 'Add Support Link',
    contactInfo: 'Contact Information',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    businessHours: 'Business Hours',
    copyright: 'Copyright',
    paymentMethods: 'Payment Methods',
    paymentMethod: 'Payment Method',
    name: 'Name',
    imageUrl: 'Image URL',
    addPaymentMethod: 'Add Payment Method'
  },
  users: {
    title: 'User Management',
    list: 'User List',
    addUser: 'Add User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    confirmDelete: 'Are you sure you want to delete this user?',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    status: 'Status',
    createdAt: 'Created At',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'User updated successfully',
    created: 'User created successfully',
    deleted: 'User deleted successfully',
    failed: 'Failed to save user',
    loadFailed: 'Failed to load users'
  },
  languages: {
    title: 'Language Management',
    list: 'Language List',
    addLanguage: 'Add Language',
    editLanguage: 'Edit Language',
    deleteLanguage: 'Delete Language',
    confirmDelete: 'Are you sure you want to delete this language?',
    code: 'Code',
    name: 'Name',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Language updated successfully',
    created: 'Language created successfully',
    deleted: 'Language deleted successfully',
    failed: 'Failed to save language',
    loadFailed: 'Failed to load languages',
    cannotRemoveEnglish: 'English cannot be removed'
  },
  destinations: {
    title: 'Popular Destinations',
    add: 'Add Destination',
    edit: 'Edit Destination',
    name: 'Name',
    description: 'Description',
    image: 'Image',
    link: 'Link',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Destination updated successfully',
    created: 'Destination created successfully',
    deleted: 'Destination deleted successfully',
    failed: 'Failed to save destination',
    loadFailed: 'Failed to load destinations',
    visible: 'Visible',
    sectionTitle: 'Section Title',
    sectionDescription: 'Section Description',
    destinations: 'Destinations',
    destination: 'Destination',
    rating: 'Rating',
    duration: 'Duration',
    badge: 'Badge'
  },
  flightDeals: {
    title: 'Prime Flight Deals',
    add: 'Add Flight Deal',
    edit: 'Edit Flight Deal',
    titleField: 'Title',
    description: 'Description',
    price: 'Price',
    image: 'Image',
    link: 'Link',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Flight deal updated successfully',
    created: 'Flight deal created successfully',
    deleted: 'Flight deal deleted successfully',
    failed: 'Failed to save flight deal',
    loadFailed: 'Failed to load flight deals',
    visible: 'Visible',
    sectionTitle: 'Section Title',
    sectionDescription: 'Section Description',
    departureOptions: 'Departure Options',
    travelerOptions: 'Traveler Options',
    flightDeals: 'Flight Deals',
    flightDeal: 'Flight Deal',
    destination: 'Destination',
    dates: 'Dates',
    prices: 'Prices',
    originalPrice: 'Original Price',
    discount: 'Discount',
    primePriceText: 'Prime Price Text',
    sellingOut: 'Selling Out',
    hot: 'Hot',
    addDepartureLocation: 'Add departure location',
    addTravelerCount: 'Add traveler count',
    departureOptionExists: 'Departure option already exists',
    itinerary: 'Itinerary',
    packages: 'Packages',
    addItineraryDay: 'Add Itinerary Day',
    dayTitle: 'Day Title',
    addActivity: 'Add Activity',
    activity: 'Activity',
    addPackage: 'Add Package',
    packageName: 'Package Name',
    packageDescription: 'Package Description',
    packageReviews: 'Reviews',
    addPackageFeature: 'Add Package Feature',
    packageFeature: 'Package Feature',
    isPopular: 'Is Popular',
    isPremium: 'Is Premium',
    imageUrl: 'Image URL',
    subtitle: 'Subtitle',
    heroSection: 'Hero Section'
  },
  services: {
    title: 'Our Travel Services',
    add: 'Add Service',
    edit: 'Edit Service',
    titleField: 'Title',
    description: 'Description',
    icon: 'Icon',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Service updated successfully',
    created: 'Service created successfully',
    deleted: 'Service deleted successfully',
    failed: 'Failed to save service',
    loadFailed: 'Failed to load services',
    visible: 'Visible',
    sectionTitle: 'Section Title',
    sectionDescription: 'Section Description',
    services: 'Services',
    service: 'Service'
  },
  hotDeals: {
    title: 'Hot Deals & Promotions',
    add: 'Add Hot Deal',
    edit: 'Edit Hot Deal',
    titleField: 'Title',
    description: 'Description',
    price: 'Price',
    image: 'Image',
    link: 'Link',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Hot deal updated successfully',
    created: 'Hot deal created successfully',
    deleted: 'Hot deal deleted successfully',
    failed: 'Failed to save hot deal',
    loadFailed: 'Failed to load hot deals',
    deals: 'Deals',
    deal: 'Deal',
    addDeal: 'Add Deal',
    validDates: 'Valid Dates',
    bookingDeadline: 'Booking Deadline',
    originalPrice: 'Original Price',
    badge: 'Badge'
  },
  hotDealDetails: {
    list: 'Hot Deal Details List',
    addHotDeal: 'Add Hot Deal Detail',
    editHotDeal: 'Edit Hot Deal Detail',
    dealKey: 'Deal Key',
    dealKeyPlaceholder: 'Enter deal key (e.g. africa)',
    title: 'Title',
    language: 'Language',
    status: 'Status',
    actions: 'Actions',
    created: 'Hot deal detail created successfully',
    updated: 'Hot deal detail updated successfully',
    deleted: 'Hot deal detail deleted successfully',
    failed: 'Failed to save hot deal detail',
    mapSection: 'Map Section',
    detailSection: 'Detail Section',
    itinerarySection: 'Recommended Itinerary',
    ctaSection: 'Call to Action (CTA)',
    sectionTitle: 'Section Title',
    sectionDescription: 'Section Description',
    enterSectionTitle: 'Enter section title',
    enterSectionDescription: 'Enter section description',
    mapMarkers: 'Map Markers',
    marker: 'Marker',
    addMarker: 'Add Marker',
    countryCode: 'Country Code',
    countryName: 'Country Name',
    color: 'Color',
    latitude: 'Latitude',
    longitude: 'Longitude',
    exampleKE: 'e.g. KE',
    exampleKenya: 'e.g. Kenya',
    countryLabel: 'Country Label',
    exampleCountryLabel: 'e.g. Kenya · Maasai Mara',
    badgeCode: 'Badge Code',
    badgeColor: 'Badge Color',
    detailTitle: 'Detail Title',
    detailDescription: 'Detail Description',
    enterDetailTitle: 'Enter detail title',
    enterDetailDescription: 'Enter detail description',
    highlights: 'Highlights',
    highlight: 'Highlight',
    addHighlight: 'Add Highlight',
    iconClass: 'Icon Class',
    iconColor: 'Icon Color',
    highlightText: 'Highlight Text',
    exampleIcon: 'e.g. fa-binoculars',
    enterHighlightDescription: 'Enter highlight description',
    tags: 'Tags',
    addTag: 'Add Tag',
    enterTagContent: 'Enter tag content',
    gallery: 'Image Gallery',
    image: 'Image',
    addImage: 'Add Image',
    imageUrl: 'Image URL',
    imageDescription: 'Image Description',
    imageTitle: 'Image Title',
    enterImageUrl: 'Enter image URL',
    enterImageDescription: 'Enter image description',
    enterImageTitle: 'Enter image title',
    upload: 'Upload',
    itineraryDays: 'Itinerary Days',
    itinerary: 'Itinerary',
    addItinerary: 'Add Itinerary',
    dayRange: 'Day Range',
    location: 'Location',
    description: 'Description',
    exampleDayRange: 'e.g. Day 1-4',
    exampleLocation: 'e.g. Kenya · Maasai Mara',
    enterItineraryDescription: 'Enter itinerary description',
    ctaBackgroundImage: 'CTA Background Image',
    ctaTitle: 'CTA Title',
    ctaDescription: 'CTA Description',
    ctaButtonText: 'CTA Button Text',
    ctaButtonLink: 'CTA Button Link',
    enterCtaTitle: 'Enter CTA title',
    enterCtaDescription: 'Enter CTA description',
    enterButtonText: 'Enter button text',
    enterButtonLink: 'Enter button link'
  },
  flashSale: {
    title: 'Flash Sale: 48 Hours Only',
    add: 'Add Flash Sale',
    edit: 'Edit Flash Sale',
    titleField: 'Title',
    description: 'Description',
    price: 'Price',
    originalPrice: 'Original Price',
    image: 'Image',
    link: 'Link',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Flash sale updated successfully',
    created: 'Flash sale created successfully',
    deleted: 'Flash sale deleted successfully',
    failed: 'Failed to save flash sale',
    loadFailed: 'Failed to load flash sale',
    countdownEndDate: 'Countdown End Date',
    flashDeals: 'Flash Deals',
    flashDeal: 'Flash Deal',
    addFlashDeal: 'Add Flash Deal',
    discount: 'Discount'
  },
  testimonials: {
    title: 'What Our Travelers Say',
    add: 'Add Testimonial',
    edit: 'Edit Testimonial',
    name: 'Name',
    comment: 'Comment',
    rating: 'Rating',
    image: 'Image',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Testimonial updated successfully',
    created: 'Testimonial created successfully',
    deleted: 'Testimonial deleted successfully',
    failed: 'Failed to save testimonial',
    loadFailed: 'Failed to load testimonials',
    testimonials: 'Testimonials',
    testimonial: 'Testimonial',
    addTestimonial: 'Add Testimonial',
    avatarUrl: 'Avatar URL',
    review: 'Review'
  },
  exclusiveDeals: {
    title: 'Get Exclusive Travel Deals',
    add: 'Add Exclusive Deal',
    edit: 'Edit Exclusive Deal',
    titleField: 'Title',
    description: 'Description',
    buttonText: 'Button Text',
    image: 'Image',
    link: 'Link',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Exclusive deal updated successfully',
    created: 'Exclusive deal created successfully',
    deleted: 'Exclusive deal deleted successfully',
    failed: 'Failed to save exclusive deal',
    loadFailed: 'Failed to load exclusive deals',
    backgroundImageUrl: 'Background Image URL',
    newsletterForm: 'Newsletter Form',
    formTitle: 'Form Title',
    formDescription: 'Form Description',
    successMessage: 'Success Message',
    privacyText: 'Privacy Text'
  },
  exclusiveTravelInsurance: {
    title: 'Exclusive Travel Insurance',
    features: 'Features',
    feature: 'Feature',
    addFeature: 'Add Feature',
    imageUrl: 'Image URL',
    buttonText: 'Button Text',
    buttonLink: 'Button Link'
  },
  heroBackground: {
    title: 'Hero Background Management',
    imageUrl: 'Background Image URL'
  },
  subscribers: {
    title: 'Subscribers Management',
    sendEmail: 'Send Email',
    emailSubject: 'Email Subject',
    emailContent: 'Email Content',
    loading: 'Loading subscribers...',
    id: 'ID',
    email: 'Email',
    name: 'Name',
    phone: 'Phone',
    status: 'Status',
    subscribedAt: 'Subscribed At',
    lastEmail: 'Last Email',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    deactivate: 'Deactivate',
    activate: 'Activate',
    enterEmailSubject: 'Enter email subject',
    enterEmailContent: 'Enter email content',
    loadFailed: 'Failed to load subscribers. Please try again.',
    loadFailedMessage: 'Failed to load subscribers',
    activateSuccess: 'Subscriber activated successfully',
    deactivateSuccess: 'Subscriber deactivated successfully',
    updateFailed: 'Failed to update subscriber status',
    enterSubjectAndContent: 'Please enter subject and content',
    sendFailed: 'Failed to send email',
    confirmDelete: 'Are you sure you want to delete subscriber {email}?',
    deleteSuccess: 'Subscriber deleted successfully',
    deleteFailed: 'Failed to delete subscriber'
  },
  header: {
    logo: 'Travelbolt CMS',
    logout: 'Logout',
    loggedInAs: 'Logged in as'
  },
  destinationDetails: {
    title: 'Destination Details Management',
    list: 'Destination Details List',
    addDestination: 'Add Destination',
    editDestination: 'Edit Destination',
    deleteDestination: 'Delete Destination',
    confirmDelete: 'Are you sure you want to delete this destination?',
    destinationKey: 'Destination Key',
    destinationKeyPlaceholder: 'Enter destination key (e.g., bali)',
    language: 'Language',
    title: 'Title',
    titlePlaceholder: 'Enter destination title',
    subtitle: 'Subtitle',
    subtitlePlaceholder: 'Enter destination subtitle',
    rating: 'Rating',
    reviews: 'Reviews',
    reviewsPlaceholder: 'Enter reviews count',
    country: 'Country',
    countryPlaceholder: 'Enter country name',
    bannerImage: 'Banner Image',
    bannerImagePlaceholder: 'Enter banner image URL',
    description: 'Description',
    descriptionPlaceholder: 'Enter destination description',
    spots: 'Secret Spots',
    spot: 'Spot',
    addSpot: 'Add Spot',
    spotName: 'Spot Name',
    spotImage: 'Spot Image',
    bestTime: 'Best Time',
    location: 'Location',
    spotDescription: 'Spot Description',
    travelTips: 'Travel Tips',
    tip: 'Tip',
    addTravelTip: 'Add Travel Tip',
    tipTitle: 'Tip Title',
    addTipItem: 'Add Tip Item',
    tipItem: 'Tip Item',
    ctaTitle: 'CTA Title',
    ctaTitlePlaceholder: 'Enter CTA title',
    ctaDescription: 'CTA Description',
    ctaDescriptionPlaceholder: 'Enter CTA description',
    cta: 'CTA',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Destination updated successfully',
    created: 'Destination created successfully',
    deleted: 'Destination deleted successfully',
    failed: 'Failed to save destination',
    loadFailed: 'Failed to load destinations'
  },
  flightDealDetails: {
    title: 'Flight Deal Details Management',
    list: 'Flight Deal Details List',
    addFlightDeal: 'Add Flight Deal',
    editFlightDeal: 'Edit Flight Deal',
    deleteFlightDeal: 'Delete Flight Deal',
    confirmDelete: 'Are you sure you want to delete this flight deal?',
    dealKey: 'Deal Key',
    dealKeyPlaceholder: 'Enter deal key (e.g., london)',
    language: 'Language',
    title: 'Title',
    titlePlaceholder: 'Enter flight deal title',
    subtitle: 'Subtitle',
    subtitlePlaceholder: 'Enter flight deal subtitle',
    rating: 'Rating',
    reviews: 'Reviews',
    reviewsPlaceholder: 'Enter reviews count',
    country: 'Country',
    countryPlaceholder: 'Enter country name',
    bannerImage: 'Banner Image',
    bannerImagePlaceholder: 'Enter banner image URL',
    overview: 'Overview',
    addOverviewFeature: 'Add Overview Feature',
    icon: 'Icon',
    featureTitle: 'Feature Title',
    featureDescription: 'Feature Description',
    itinerary: 'Itinerary',
    addItinerary: 'Add Itinerary',
    addItineraryDay: 'Add Itinerary Day',
    dayTitle: 'Day Title',
    addActivity: 'Add Activity',
    addPackageSection: 'Add Package Section',
    activity: 'Activity',
    packages: 'Packages',
    addPackage: 'Add Package',
    packageName: 'Package Name',
    packageDescription: 'Package Description',
    price: 'Price',
    originalPrice: 'Original Price',
    packageReviews: 'Reviews',
    addPackageFeature: 'Add Package Feature',
    packageFeature: 'Package Feature',
    isPopular: 'Is Popular',
    isPremium: 'Is Premium',
    reviews: 'Reviews',
    addReview: 'Add Review',
    reviewerName: 'Reviewer Name',
    avatar: 'Avatar URL',
    reviewContent: 'Review Content',
    reviewDate: 'Review Date',
    ctaTitle: 'CTA Title',
    ctaTitlePlaceholder: 'Enter CTA title',
    ctaDescription: 'CTA Description',
    ctaDescriptionPlaceholder: 'Enter CTA description',
    cta: 'CTA',
    sectionVisibility: 'Section Visibility',
    reviewsSection: 'Reviews Section',
    addImage: 'Add Image',
    sectionTitle: 'Section Title',
    description: 'Description',
    imageUrl: 'Image URL',
    dealKeyRequired: 'Deal key is required',
    languageRequired: 'Language is required',
    titleRequired: 'Title is required',
    countryRequired: 'Country is required',
    status: 'Status',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    updated: 'Flight deal updated successfully',
    created: 'Flight deal created successfully',
    deleted: 'Flight deal deleted successfully',
    failed: 'Failed to save flight deal',
    loadFailed: 'Failed to load flight deals',
    tripOverview: 'Trip Overview',
    tripOverviewTitle: 'Trip Overview Title',
    tripOverviewDescription: 'Trip Overview Description',
    tripOverviewDays: 'Days',
    tripOverviewDaysPlaceholder: 'Enter trip days',
    tripOverviewDaysDescription: 'Days Description',
    tripOverviewDaysDescriptionPlaceholder: 'Enter days description',
    tripOverviewBestSeason: 'Best Season',
    tripOverviewBestSeasonPlaceholder: 'Enter best season',
    tripOverviewSeasonDescription: 'Season Description',
    tripOverviewSeasonDescriptionPlaceholder: 'Enter season description',
    tripOverviewTravelStyle: 'Travel Style',
    tripOverviewTravelStylePlaceholder: 'Enter travel style',
    tripOverviewStyleDescription: 'Style Description',
    tripOverviewStyleDescriptionPlaceholder: 'Enter style description',
    labelSettings: 'Label Settings',
    daysLabel: 'Days Label',
    daysLabelPlaceholder: 'Enter days label',
    seasonLabel: 'Season Label',
    seasonLabelPlaceholder: 'Enter season label',
    styleLabel: 'Style Label',
    styleLabelPlaceholder: 'Enter style label',
    packageButtonText: 'Package Button Text',
    packageButtonTextPlaceholder: 'Enter package button text',
    packageButtonLink: 'Package Button Link',
    packageButtonLinkPlaceholder: 'Enter package button link',
    ctaButtonText: 'CTA Button Text',
    ctaButtonTextPlaceholder: 'Enter CTA button text',
    ctaButtonLink: 'CTA Button Link',
    ctaButtonLinkPlaceholder: 'Enter CTA button link',
    overviewButtonText: 'Overview Button Text',
    overviewButtonTextPlaceholder: 'Enter overview button text (e.g., View 6-day itinerary inspiration)',
    popularLabelPlaceholder: 'Popular label text (e.g., Popular)',
    premiumLabelPlaceholder: 'Premium label text (e.g., Premium)'
  },
  faqs: {
    title: 'FAQ Management',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    addFaq: 'Add FAQ',
    editFaq: 'Edit FAQ',
    title: 'Title',
    order: 'Order',
    visible: 'Visible',
    question: 'Question',
    answer: 'Answer',
    faqs: 'FAQs',
    saveSuccess: 'Saved successfully',
    updateSuccess: 'Updated successfully',
    deleteSuccess: 'Deleted successfully',
    saveError: 'Failed to save',
    updateError: 'Failed to update',
    deleteError: 'Failed to delete',
    loadError: 'Failed to load'
  },
  aboutUs: {
    title: 'About Us Management',
    content: 'Content',
    hero: 'Hero Section',
    heroTitle: 'Hero Title',
    enterHeroTitle: 'Enter hero title',
    heroSubtitle: 'Hero Subtitle',
    enterHeroSubtitle: 'Enter hero subtitle',
    heroDescription: 'Hero Description',
    enterHeroDescription: 'Enter hero description',
    mission: 'Mission Section',
    missionBadge: 'Mission Badge',
    enterMissionBadge: 'Enter mission badge',
    missionTitle: 'Mission Title',
    enterMissionTitle: 'Enter mission title',
    missionContent: 'Mission Content',
    enterMissionParagraph: 'Enter mission paragraph {index}',
    addMissionParagraph: 'Add Mission Paragraph',
    whyChooseUs: 'Why Choose Us Section',
    whyChooseUsBadge: 'Why Choose Us Badge',
    enterWhyChooseUsBadge: 'Enter why choose us badge',
    whyChooseUsTitle: 'Why Choose Us Title',
    enterWhyChooseUsTitle: 'Enter why choose us title',
    whyChooseUsItems: 'Why Choose Us Items',
    itemIcon: 'Item Icon',
    enterItemIcon: 'Enter item icon',
    itemTitle: 'Item Title',
    enterItemTitle: 'Enter item title',
    itemDescription: 'Item Description',
    enterItemDescription: 'Enter item description',
    addWhyChooseUsItem: 'Add Why Choose Us Item',
    contactInfo: 'Contact Info Section',
    contactInfoBadge: 'Contact Info Badge',
    enterContactInfoBadge: 'Enter contact info badge',
    contactInfoTitle: 'Contact Info Title',
    enterContactInfoTitle: 'Enter contact info title',
    contactInfoDescription: 'Contact Info Description',
    enterContactInfoDescription: 'Enter contact info description',
    officeTitle: 'Office Title',
    enterOfficeTitle: 'Enter office title',
    officeIcon: 'Office Icon',
    enterOfficeIcon: 'Enter office icon',
    office: 'Office',
    enterOffice: 'Enter office address',
    phoneTitle: 'Phone Title',
    enterPhoneTitle: 'Enter phone title',
    phoneIcon: 'Phone Icon',
    enterPhoneIcon: 'Enter phone icon',
    phone: 'Phone',
    enterPhone: 'Enter phone number',
    phoneHours: 'Phone Hours',
    enterPhoneHours: 'Enter phone hours',
    emailTitle: 'Email Title',
    enterEmailTitle: 'Enter email title',
    emailIcon: 'Email Icon',
    enterEmailIcon: 'Enter email icon',
    email: 'Email',
    enterEmail: 'Enter email address',
    emailResponse: 'Email Response',
    enterEmailResponse: 'Enter email response time'
  },
  privacyPolicy: {
    title: 'Privacy Policy Management',
    content: 'Content',
    heroTitle: 'Hero Title',
    enterHeroTitle: 'Enter hero title',
    heroSubtitle: 'Hero Subtitle',
    enterHeroSubtitle: 'Enter hero subtitle',
    lastUpdated: 'Last Updated',
    enterLastUpdated: 'Enter last updated date',
    note: 'Note',
    enterNote: 'Enter note',
    part1Title: 'Part 1 Title',
    enterPart1Title: 'Enter part 1 title',
    ourPledge: 'Our Pledge',
    enterOurPledge: 'Enter our pledge',
    cookies: 'Cookies',
    enterCookies: 'Enter cookies text',
    enterCookiesText1: 'Enter cookies text',
    enterCookiesText2: 'Enter cookies text',
    analytics: 'Analytics',
    enterAnalytics: 'Enter analytics text',
    enterAnalyticsText: 'Enter analytics text',
    remarketing: 'Remarketing',
    enterRemarketing: 'Enter remarketing text',
    enterRemarketingText: 'Enter remarketing text',
    optingOut: 'Opting Out',
    enterOptingOut: 'Enter opting out text',
    enterOptingOutText1: 'Enter opting out text',
    enterOptingOutText2: 'Enter opting out text',
    collection: 'Collection',
    enterCollection: 'Enter collection text',
    enterCollectionText1: 'Enter collection text',
    enterCollectionText2: 'Enter collection text',
    useOfData: 'Use of Personal Data',
    enterUseOfData: 'Enter use of data text',
    enterUseOfDataText: 'Enter use of data text',
    retention: 'Retention',
    enterRetention: 'Enter retention text',
    enterRetentionText: 'Enter retention text',
    access: 'Access and Correction',
    enterAccess: 'Enter access text',
    enterAccessText1: 'Enter access text',
    accessItem1: 'Access Item 1',
    enterAccessItem1: 'Enter access item 1',
    accessItem2: 'Access Item 2',
    enterAccessItem2: 'Enter access item 2',
    accessItem3: 'Access Item 3',
    enterAccessItem3: 'Enter access item 3',
    accessItem4: 'Access Item 4',
    enterAccessItem4: 'Enter access item 4',
    accessItem5: 'Access Item 5',
    enterAccessItem5: 'Enter access item 5',
    enterAccessText2: 'Enter access text',
    byPost: 'By Post',
    enterAddress: 'Enter address',
    byEmail: 'By Email',
    enterEmail: 'Enter email',
    enterAccessText3: 'Enter access text',
    security: 'Security',
    enterSecurity: 'Enter security text',
    enterSecurityText: 'Enter security text',
    part2Title: 'Part 2 Title',
    enterPart2Title: 'Enter part 2 title',
    enterPersonalInformation: 'Enter personal information text',
    enterPersonalInformationText1: 'Enter personal information text',
    enterPersonalInformationText2: 'Enter personal information text',
    enterPersonalInformationText3: 'Enter personal information text',
    purposes: 'Purposes for Collecting Personal Information',
    enterPurposes: 'Enter purposes text',
    enterPurpose1: 'Enter purpose 1',
    enterPurpose2: 'Enter purpose 2',
    enterPurpose3: 'Enter purpose 3',
    enterPurpose4: 'Enter purpose 4',
    enterPurpose5: 'Enter purpose 5',
    enterPurpose6: 'Enter purpose 6',
    enterPurpose7: 'Enter purpose 7',
    enterPurpose8: 'Enter purpose 8',
    enterPurpose9: 'Enter purpose 9',
    enterPurpose10: 'Enter purpose 10',
    enterPurpose11: 'Enter purpose 11',
    enterPurpose12: 'Enter purpose 12',
    enterPurpose13: 'Enter purpose 13',
    enterPurpose14: 'Enter purpose 14',
    enterRecipientsText: 'Enter recipients text',
    recipients: 'Recipients of Personal Information',
    enterRecipients: 'Enter recipients text',
    enterRecipient1: 'Enter recipient 1',
    enterRecipient2: 'Enter recipient 2',
    enterRecipient3: 'Enter recipient 3',
    enterRecipient4: 'Enter recipient 4',
    enterRecipient5: 'Enter recipient 5',
    enterRecipient6: 'Enter recipient 6',
    enterRecipient7: 'Enter recipient 7',
    enterUnsubscribe: 'Enter unsubscribe text',
    enterUnsubscribeText: 'Enter unsubscribe text',
    enterConsent: 'Enter consent text',
    enterConsentText: 'Enter consent text',
    enterContact: 'Enter contact text',
    enterContactText: 'Enter contact text',
    enterWebsiteNote: 'Enter website note'
  },
  termsAndConditions: {
    title: 'Terms and Conditions Management',
    content: 'Content',
    heroTitle: 'Hero Title',
    enterHeroTitle: 'Enter hero title',
    heroSubtitle: 'Hero Subtitle',
    enterHeroSubtitle: 'Enter hero subtitle',
    lastUpdated: 'Last Updated',
    enterLastUpdated: 'Enter last updated date',
    part1Title: 'Part 1 Title',
    enterPart1Title: 'Enter part 1 title',
    introduction: 'Introduction',
    enterIntroduction: 'Enter introduction text',
    enterIntroductionText: 'Enter introduction text',
    enterIntroductionText1: 'Enter introduction text',
    enterIntroductionText2: 'Enter introduction text',
    copyrightNotice: 'Copyright Notice',
    enterCopyrightNotice: 'Enter copyright notice text',
    enterCopyrightText: 'Enter copyright text',
    enterCopyrightText1: 'Enter copyright text',
    enterCopyrightText2: 'Enter copyright text',
    trademarkNotice: 'Trademark Notice',
    enterTrademarkNotice: 'Enter trademark notice text',
    enterTrademarkNoticeText: 'Enter trademark notice text',
    enterTrademarkText: 'Enter trademark text',
    acceptableUse: 'Acceptable Use',
    enterAcceptableUse: 'Enter acceptable use text',
    enterAcceptableUseText1: 'Enter acceptable use text',
    enterAcceptableUseText2: 'Enter acceptable use text',
    enterAcceptableUseText3: 'Enter acceptable use text',
    noWarranties: 'No Warranties',
    enterNoWarranties: 'Enter no warranties text',
    enterNoWarrantiesText1: 'Enter no warranties text',
    noWarrantiesItem1: 'No Warranties Item 1',
    enterNoWarrantiesItem1: 'Enter no warranties item 1',
    noWarrantiesItem2: 'No Warranties Item 2',
    enterNoWarrantiesItem2: 'Enter no warranties item 2',
    noWarrantiesItem3: 'No Warranties Item 3',
    enterNoWarrantiesItem3: 'Enter no warranties item 3',
    noWarrantiesItem4: 'No Warranties Item 4',
    enterNoWarrantiesItem4: 'Enter no warranties item 4',
    noWarrantiesItem5: 'No Warranties Item 5',
    enterNoWarrantiesItem5: 'Enter no warranties item 5',
    noWarrantiesItem6: 'No Warranties Item 6',
    enterNoWarrantiesItem6: 'Enter no warranties item 6',
    noWarrantiesItem7: 'No Warranties Item 7',
    enterNoWarrantiesItem7: 'Enter no warranties item 7',
    enterNoWarrantiesText2: 'Enter no warranties text',
    generalLimitation: 'General Limitation of Liability',
    enterGeneralLimitation: 'Enter general limitation text',
    enterGeneralLimitationText1: 'Enter general limitation text',
    enterGeneralLimitationText2: 'Enter general limitation text',
    enterGeneralLimitationText3: 'Enter general limitation text',
    enterGeneralLimitationText4: 'Enter general limitation text',
    enterGeneralLimitationText5: 'Enter general limitation text',
    thirdParties: 'Third Parties',
    enterThirdParties: 'Enter third parties text',
    enterThirdPartiesText1: 'Enter third parties text',
    enterThirdPartiesText2: 'Enter third parties text',
    thirdPartyTravelService: 'Third Party Travel Service Providers',
    enterThirdPartyTravelService: 'Enter third party travel service text',
    enterThirdPartyTravelServiceText1: 'Enter third party travel service text',
    enterThirdPartyTravelServiceText2: 'Enter third party travel service text',
    userComments: 'User Comments',
    enterUserComments: 'Enter user comments text',
    enterUserCommentsText: 'Enter user comments text',
    responseToRequests: 'Response to Requests',
    enterResponseToRequests: 'Enter response to requests text',
    enterResponseToRequestsText: 'Enter response to requests text',
    linksToOther: 'Links to Other Websites',
    enterLinksToOther: 'Enter links to other websites text',
    enterLinksToOtherText: 'Enter links to other websites text',
    terminationOfUsage: 'Termination of Usage',
    enterTerminationOfUsage: 'Enter termination of usage text',
    enterTerminationOfUsageText: 'Enter termination of usage text',
    pricingErrors: 'Pricing Errors',
    enterPricingErrors: 'Enter pricing errors text',
    enterPricingErrorsText1: 'Enter pricing errors text',
    enterPricingErrorsText2: 'Enter pricing errors text',
    enterPricingErrorsText3: 'Enter pricing errors text',
    creditCardSubmissions: 'Credit Card Submissions',
    enterCreditCardSubmissions: 'Enter credit card submissions text',
    enterCreditCardSubmissionsText: 'Enter credit card submissions text',
    membershipLoyalty: 'Membership and Loyalty Programs',
    enterMembershipLoyalty: 'Enter membership loyalty text',
    enterMembershipLoyaltyText: 'Enter membership loyalty text',
    miscellaneous: 'Miscellaneous',
    enterMiscellaneous: 'Enter miscellaneous text',
    enterMiscellaneousText1: 'Enter miscellaneous text',
    miscellaneousItem1: 'Miscellaneous Item 1',
    enterMiscellaneousItem1: 'Enter miscellaneous item 1',
    miscellaneousItem2: 'Miscellaneous Item 2',
    enterMiscellaneousItem2: 'Enter miscellaneous item 2',
    enterMiscellaneousText2: 'Enter miscellaneous text',
    enterMiscellaneousText3: 'Enter miscellaneous text',
    enterMiscellaneousText4: 'Enter miscellaneous text',
    enterMiscellaneousText5: 'Enter miscellaneous text',
    part2Title: 'Part 2 Title',
    enterPart2Title: 'Enter part 2 title',
    limitationOfLiability: 'Limitation of Liability',
    enterLimitationOfLiability: 'Enter limitation of liability text',
    enterLimitationOfLiabilityText: 'Enter limitation of liability text',
    ticketRestrictions: 'Ticket Restrictions',
    enterTicketRestrictions: 'Enter ticket restrictions text',
    enterTicketRestrictionsText: 'Enter ticket restrictions text',
    ticketPayment: 'Ticket Payment',
    enterTicketPayment: 'Enter ticket payment text',
    enterTicketPaymentText: 'Enter ticket payment text',
    otherServiceFee: 'Other Service Fee',
    enterOtherServiceFee: 'Enter other service fee text',
    enterOtherServiceFeeText: 'Enter other service fee text',
    service: 'Service',
    fee: 'Fee',
    service1: 'Booking Fee',
    service2: 'Cancellation Fee',
    service3: 'Change Fee',
    fuelSurcharge: 'Fuel Surcharge',
    enterFuelSurcharge: 'Enter fuel surcharge text',
    enterFuelSurchargeText: 'Enter fuel surcharge text',
    useOfTicket: 'Use of Ticket',
    enterUseOfTicket: 'Enter use of ticket text',
    enterUseOfTicketText1: 'Enter use of ticket text',
    enterUseOfTicketText2: 'Enter use of ticket text',
    enterUseOfTicketText3: 'Enter use of ticket text',
    enterUseOfTicketText4: 'Enter use of ticket text',
    refundPolicy: 'Refund Policy',
    enterRefundPolicy: 'Enter refund policy',
    serviceFeeManagement: 'Service Fee Management',
    addService: 'Add Service',
    enterServiceName: 'Enter service name',
    enterServiceFee: 'Enter service fee',
    noServicesAdded: 'No services added yet, please click the add service button',
    internationalTravel: 'International Travel',
    enterInternationalTravel: 'Enter international travel text',
    enterInternationalTravelText: 'Enter international travel text'
  }
}